<div class="timesheet-calendar">

  <div class="header">
    <h2>{{ headerTitle }}</h2>
    <emerald-icon class="close-icon"
                  [icon]="'close'"
                  (click)="close()">
    </emerald-icon>
  </div>

  <div class="candidate-details">
    <p class="candidate-employeeName">{{ candidateDetails.employeeName }}</p>
    <p class="candidate-jobTitle">{{ candidateDetails.jobTitle }}</p>
    <p class="candidate-location" *ngIf="candidateDetails.location">{{ candidateDetails.location }}</p>
  </div>

  <!-- Action dropdown — always visible -->
  <div class="action-select-wrapper">
    <label class="action-select-label">Select leave type / billing dates</label>
    <select class="action-select" [(ngModel)]="selectedAction" name="selectedAction" (ngModelChange)="onActionChange()">
      <option value="" disabled selected>Select Action</option>
      <option value="billing">Calculate Billing Hours</option>
      <option *ngFor="let type of leaveTypeOptions" [value]="type.value">{{ type.label }}</option>
      <option *ngIf="hasBillingDatesForCurrentMonth" value="unselect">Unselect</option>
    </select>
  </div>

  <div class="calendar-wrapper">
    <mat-calendar
      #calendar
      [dateClass]="dateClass"
      [startAt]="selectedDateValue"
      (selectedChange)="onDateSelected($event)"
      (viewChanged)="onViewChanged()"
      [selected]="effectiveSelection"
    ></mat-calendar>

    <!-- Individual / Range choice popup -->
    <div
      #modeChoiceRef
      *ngIf="showModeChoicePopup"
      class="mode-choice-popup"
      [style.top.px]="modeChoicePosition.top"
      [style.left.px]="modeChoicePosition.left"
    >
      <div class="mode-choice-label">Apply as:</div>
      <div (mousedown)="chooseIndividualMode()" class="mode-choice-option">
        <span class="mode-choice-icon">&#9679;</span> Individual Dates
      </div>
      <div (mousedown)="chooseRangeMode()" class="mode-choice-option">
        <span class="mode-choice-icon">&#8596;</span> Date Range
      </div>
    </div>

    <div class="summary">
      <div *ngFor="let item of getFilteredSummary()" class="summary-item">
        <div class="summary-text">{{ item.text }}</div>
        <div class="summary-value">{{ item.value }}</div>
      </div>
    </div>
  </div>

  <div class="legend">
    <div class="legend-item" *ngFor="let item of getFilteredLegendItems()">
      <span class="legend-color" [ngClass]="item.class"></span>
      <span>{{ item.label }}</span>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Actions — always visible -->
  <div class="actions">
    <emerald-button
      class="cancel-button"
      [type]="'Secondary'"
      (click)="cancel()"
      *ngIf="selectedEmployeeTimesheet?.status !== 'Approved' && selectedEmployeeTimesheet?.status !== 'Pending Approval'"
    >{{ buttonLabels.Cancel }}</emerald-button>
    <emerald-button
      class="submit-button"
      [disabled]="!selectedAction || !hasSelectedDates()"
      (click)="applyAction($event)"
    >{{ buttonLabels.Submit }}</emerald-button>
  </div>

  <!-- Chat window — always visible -->
  <div class="chat-window">
    <div class="chat-history" *ngIf="commentHistory?.length">
      <ng-container *ngFor="let item of commentHistory">
        <div *ngIf="item.managerComments" class="chat-message left">
          <div class="chat-header">
            <span class="chat-avatar">{{ item.commentedManagerName && item.commentedManagerName[0] }}</span>
          </div>
          <div class="chat-message-content">
            <div class="chat-name">{{ item.commentedManagerName }}</div>
            <div class="chat-meta">
              {{ item.managerCommentsDate | date: dateFormat.dateTime }}
            </div>
            <div class="chat-text">{{ item.managerComments }}</div>
          </div>
        </div>
        <div *ngIf="item.vendorComments" class="chat-message right">
          <div class="chat-message-content">
            <div class="chat-name">{{ item.commentedVendorName }}</div>
            <div class="chat-meta">
              {{ item.vendorCommentsDate | date: dateFormat.dateTime }}
            </div>
            <div class="chat-text">{{ item.vendorComments }}</div>
          </div>
          <div class="chat-header">
            <span class="chat-avatar">{{ item.commentedVendorName && item.commentedVendorName[0] }}</span>
          </div>
        </div>
      </ng-container>
    </div>
    <form class="chat-input-row" (ngSubmit)="sendMessage()">
      <textarea
        [(ngModel)]="newMessage"
        name="newMessage"
        class="chat-textarea"
        rows="2"
        placeholder="Comment*"
      ></textarea>
      <div class="actions">
        <emerald-button class="cancel-button" [type]="'Secondary'" (click)="cancel()">{{ buttonLabels.Cancel }}</emerald-button>
        <emerald-button class="submit-button">{{ buttonLabels.Comments }}</emerald-button>
      </div>
    </form>
  </div>

</div>